import React, { useState, useEffect } from 'react';
import { useCart } from '../CartContext';
import { useAuth } from '../AuthContext';
import toast from 'react-hot-toast';
import './Navbar.css';

export default function Navbar({ navigate, currentPage }) {
  const { itemCount } = useCart();
  const { user, logout } = useAuth();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [profileOpen, setProfileOpen] = useState(false);
  const [location, setLocation] = useState('Detecting location...');

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (pos) => {
          try {
            const { latitude, longitude } = pos.coords;
            const res = await fetch(`https://nominatim.openstreetmap.org/reverse?lat=${latitude}&lon=${longitude}&format=json`);
            const data = await res.json();
            const area = data.address?.suburb || data.address?.neighbourhood || data.address?.city_district || data.address?.city || 'Your Area';
            const city = data.address?.city || data.address?.town || '';
            setLocation(`${area}${city ? ', ' + city : ''}`);
          } catch { setLocation('Pune, Maharashtra'); }
        },
        () => setLocation('Pune, Maharashtra')
      );
    } else { setLocation('Pune, Maharashtra'); }
  }, []);

  const handleLogout = () => { logout(); toast.success('Logged out!'); navigate('home'); setProfileOpen(false); };

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-inner">
        <div className="navbar-brand" onClick={() => navigate('home')}>
          <span className="brand-icon">🌿</span>
          <span className="brand-name">FreshMart</span>
        </div>

        <div className="location-pill">
          <span>📍</span>
          <span className="location-text">{location}</span>
        </div>

        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          {['home', 'products'].map(p => (
            <button key={p} className={`nav-link ${currentPage === p ? 'active' : ''}`}
              onClick={() => { navigate(p); setMenuOpen(false); }}>
              {p === 'home' ? '🏠 Home' : '🛒 Shop'}
            </button>
          ))}
          {user?.role === 'admin' && (
            <button className="nav-link admin-link" onClick={() => { navigate('admin'); setMenuOpen(false); }}>
              👑 Admin
            </button>
          )}
        </div>

        <div className="navbar-actions">
          <button className="cart-btn" onClick={() => navigate('cart')}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
              <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/>
            </svg>
            {itemCount > 0 && <span className="cart-badge">{itemCount}</span>}
          </button>

          {user ? (
            <div className="profile-wrap">
              <button className="profile-btn" onClick={() => setProfileOpen(!profileOpen)}>
                <div className="profile-avatar">{user.avatar}</div>
                <span className="profile-name">{user.name.split(' ')[0]}</span>
                <span>▾</span>
              </button>
              {profileOpen && (
                <div className="profile-dropdown">
                  <div className="dropdown-header">
                    <div className="dropdown-avatar">{user.avatar}</div>
                    <div>
                      <p className="dropdown-name">{user.name}</p>
                      <p className="dropdown-email">{user.email}</p>
                    </div>
                  </div>
                  <div className="dropdown-divider"/>
                  {user.role === 'admin' && (
                    <button className="dropdown-item admin-item" onClick={() => { navigate('admin'); setProfileOpen(false); }}>
                      👑 Admin Panel
                    </button>
                  )}
                  <button className="dropdown-item" onClick={() => { navigate('profile'); setProfileOpen(false); }}>
                    🛒 My Orders
                  </button>
                  <div className="dropdown-divider"/>
                  <button className="dropdown-item logout-item" onClick={handleLogout}>
                    🚪 Logout
                  </button>
                </div>
              )}
            </div>
          ) : (
            <div className="auth-btns">
              <button className="btn-ghost" onClick={() => navigate('login')}>Sign In</button>
              <button className="btn-signup" onClick={() => navigate('signup')}>Sign Up</button>
            </div>
          )}
          <button className="hamburger" onClick={() => setMenuOpen(!menuOpen)}>
            <span/><span/><span/>
          </button>
        </div>
      </div>
    </nav>
  );
}
